var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPhotosAvailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9375 8.3125H2C1.44771 8.3125 1 8.76021 1 9.3125V26.5125C1 27.0648 1.44771 27.5125 2 27.5125H30C30.5523 27.5125 31 27.0648 31 26.5125V9.3125C31 8.76021 30.5523 8.3125 30 8.3125H20.8625V6C20.8625 5.44772 20.4148 5 19.8625 5H11.9375C11.3852 5 10.9375 5.44772 10.9375 6V8.3125ZM9.9375 6C9.9375 4.89543 10.8329 4 11.9375 4H19.8625C20.9671 4 21.8625 4.89543 21.8625 6V7.3125H30C31.1046 7.3125 32 8.20793 32 9.3125V26.5125C32 27.6171 31.1046 28.5125 30 28.5125H2C0.895431 28.5125 0 27.6171 0 26.5125V9.3125C0 8.20793 0.895431 7.3125 2 7.3125H9.9375V6Z",
    fill: "#787395"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9004 23.5371C19.007 23.5371 21.5254 21.0187 21.5254 17.9121C21.5254 14.8055 19.007 12.2871 15.9004 12.2871C12.7938 12.2871 10.2754 14.8055 10.2754 17.9121C10.2754 21.0187 12.7938 23.5371 15.9004 23.5371ZM15.9004 24.5371C19.5593 24.5371 22.5254 21.571 22.5254 17.9121C22.5254 14.2532 19.5593 11.2871 15.9004 11.2871C12.2415 11.2871 9.27539 14.2532 9.27539 17.9121C9.27539 21.571 12.2415 24.5371 15.9004 24.5371Z",
    fill: "#787395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1883 11.6129C23.3678 11.6129 23.5133 11.4674 23.5133 11.2879C23.5133 11.1084 23.3678 10.9629 23.1883 10.9629C23.0088 10.9629 22.8633 11.1084 22.8633 11.2879C22.8633 11.4674 23.0088 11.6129 23.1883 11.6129ZM23.1883 12.6129C23.9201 12.6129 24.5133 12.0197 24.5133 11.2879C24.5133 10.5561 23.9201 9.96289 23.1883 9.96289C22.4565 9.96289 21.8633 10.5561 21.8633 11.2879C21.8633 12.0197 22.4565 12.6129 23.1883 12.6129Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhotosAvailable);
export default __webpack_public_path__ + "static/media/no-photos-available.97467560.svg";
export { ForwardRef as ReactComponent };